import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["fileInput", "uploadUrl", "documentsUrl", "uploadButton"]
  connect() {
    this.uploadUrl = this.uploadUrlTarget.value
    console.log("🚀 ~ extends ~ connect ~ this.uploadUrl:", this.uploadUrl)
    this.documentsUrl = this.documentsUrlTarget.value
    console.log("🚀 ~ extends ~ connect ~ this.documentsUrl:", this.documentsUrl)
  }

  triggerFileInput() {
    this.fileInputTarget.click()
  }

  async uploadFile() {
    const file = this.fileInputTarget.files[0]
    if (!file) {
      alert("Debe seleccionar un archivo PDF")
      return
    }
    console.log("🚀 ~ extends ~ uploadFile ~ file:", file)

    const formData = new FormData()
    formData.append('unsigned_file', file)

    const response = await fetch(this.uploadUrl, {
      method: 'POST',
      body: formData
    })

    if (response.ok) {
      console.log("✅ Archivo subido exitosamente")
      const patchResponse = await fetch(this.documentsUrl, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          filename: file.name,
          status: "uploaded"
        })
      })

      if (patchResponse.ok) {
        const json = await patchResponse.json()
        console.log("📄 Documento actualizado:", json)
        this.uploadButtonTarget.classList.add("hidden")
        document.getElementById("firmaContainer").classList.remove("hidden")
      } else {
        const errText = await patchResponse.text()
        console.error("❌ Error al actualizar documento:", errText)
      }
    } else {
      console.error("❌ Error al subir archivo")
    }
  }
}